import React, { useState, useEffect } from "react";
import LoginHeader from "../../Layouts/LoginRouteLayouts/LoginHeader";
import { useNavigate, useLocation } from "react-router-dom";

export default function LoginRoute({ children }) {
  const laung = localStorage.getItem("laung");
  const [lan] = useState(laung ?? "en");
  const navigate = useNavigate();
  const location = useLocation();
  const urexperttoken = localStorage.getItem("urexperttoken");

  useEffect(() => {
    if (urexperttoken && urexperttoken.length > 15) {
      const pathname = location.pathname;

      const allowedPaths = [
        "/forgetpassword",
        "/forgetpasswordwithmobileno",
        "/loginwithemail",
      ];

      const isAllowed = allowedPaths.some(path => pathname.endsWith(path));

      // ✅ Only redirect if user is on a login page AND came directly here (not via back button)
      if (isAllowed && !location.state?.fromProtected) {
        navigate(`/${lan}`, { replace: true });
      }
    }
  }, [urexperttoken, lan, navigate, location]);

  return (
    <div>
      <LoginHeader />
      {children}
    </div>
  );
}
